module.exports = __webpack_public_path__ + "img/2.ba824a9b.png";